import { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Switch from "react-switch";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { io } from "socket.io-client";
import { AddAttendenceAPI, getLatestBreak, getSingleAttendence, updateBreakByUserId } from "../../API/Api";
import userImg from "../../assets/Images/DefaultProfileLogo.png";
import { setLastSession, setLatestBreak, setNotification } from "../../Redux/Slice/LoginSlice";
import SessionModel from "../Modals/SessionModel";
import Greetings from "../Settings/Greetings/Greetings";
import { formBtn1, pageClass } from "../Utils/CustomClasses";
import { NotificationSlide } from "./NotificationSlide";
import { environment } from "../../API/env";
import { useLocation } from "react-router-dom";
import { IconExclamationCircle,IconCircleCheck, IconLogout, IconUser, IconMenu2, IconX, IconChevronDown } from "@tabler/icons-react";
import { renderToString } from "react-dom/server";

export default function NavSettings({ mobileSidebar, setMobileSidebar, nLogout }) {
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const [openSlide, setOpenSlide] = useState(false);
  const [breakmodal, setBreakModal] = useState(false);
  const [value, setValue] = useState(false);
  const [card, setCard] = useState(false);
  const loginDetails = useSelector((state) => state?.login?.lastSession);
  const latestBreak = useSelector((state) => state?.login?.latestBreak);
  const dispatch = useDispatch();
  const socketRef = useRef(null);
  const location = useLocation();
  const hideGreetingRoutes = ["/emp-status"];
  const showGreeting = !hideGreetingRoutes.includes(location.pathname);

  useEffect(() => {
    if (!userDetails?._id) return;

    if (socketRef.current) {
      socketRef.current.disconnect();
    }

    const socket = io(environment.web_socket_url, {
      transports: ['websocket'],
      withCredentials: false,
      auth: {
        socketSecretKey: process.env.REACT_APP_SOCKET_SECRET_KEY,
        userId: userDetails._id,
      },
    });

    socketRef.current = socket;

    socket.on('connect', () => {
      console.log("Connected to WebSocket server=---");

      if (userDetails?.role?.roleName === "Admin") {
        // Join company room so admin gets company-wide notifications
        socket.emit("join-room", userDetails?.company?._id);
      } else {
        // Staff join only their own room
        socket.emit("join-room", userDetails._id);
      }
    });

    socket.on("connect_error", (err) => {
      console.error("Socket connection error:=--", err.message);
    });

    socket.on("notification_update", (data) => {
      console.log("notification update event received:--", data);
      dispatch(setNotification(data));

    });

    return () => {
      if (socketRef.current) {
        socketRef.current.emit(
          "leave-room",
          userDetails?.role?.roleName === "Admin" ? userDetails?.company?._id : userDetails._id
        );
        socketRef.current.off("notification_update");
        socketRef.current.disconnect();
        socketRef.current = null;
        console.log("Disconnected from WebSocket server");
      }
    };

  }, [userDetails?._id]);

  const Break = async () => {
  try {
    let userPayload = {
      userId: userDetails._id,
      companyId: userDetails?.company?._id
    };

    updateBreakByUserId(userPayload).then(async res => {

      if (res.status == 200) {

        Swal.fire({
          html: `
            <div class="flex flex-col items-center gap-2 -mt-4">

              <div class="w-[120px] h-[120px] bg-[#E6FAEE] rounded-full flex items-center justify-center">
                ${renderToString(
                  <IconCircleCheck size={64} color="#22C55E" />
                )}
              </div>

              <h2 class="text-[28px] font-bold text-[#4A5565] leading-[140%]">
                Success
              </h2>

              <p class="text-[20px] font-medium text-[#4A5565] text-center">
                Logged back from break successfully!
              </p>

            </div>
          `,
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: {
            popup: "rounded-xl px-6 py-4",
            actions: "flex justify-center mt-4",
            confirmButton:
              "w-[100px] h-[44px] bg-[var(--bg-base-color)] text-white rounded-md flex items-center justify-center",
          },
        });
        setValue(true);
        await getLatestBreak(userDetails?._id).then((res) => {
          if (res.status === 200) {
            dispatch(setLatestBreak(res?.data?.data));
          }
        })
      } else {
        setValue(false);
        Swal.fire({
          html: `
            <div class="flex flex-col items-center gap-2 -mt-4">

              <div class="w-[120px] h-[120px] bg-[#FEF9C2] rounded-full flex items-center justify-center">
                ${renderToString(
                  <IconExclamationCircle size={64} color="#F59E0B" />
                )}
              </div>

              <h2 class="text-[28px] font-bold text-[#4A5565] leading-[140%]">
                Warning
              </h2>

              <p class="text-[20px] font-medium text-[#4A5565] text-center">
                Break Not Applied
              </p>

            </div>
          `,
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: {
            popup: "rounded-xl px-6 py-4",
            actions: "flex justify-center mt-4",
            confirmButton:
              "w-[100px] h-[44px] bg-[var(--bg-base-color)] text-white rounded-md flex items-center justify-center",
          },
        });
      }
    });
  } catch (err) {
    setValue(false);
    console.log("err");
  }
};

  const attendencelogin = async () => {
  try {
    setValue(true);

    const payload = {
      company: userDetails?.company?._id,
      remark: "Working",
      userId: userDetails?._id,
    };

    let response = await AddAttendenceAPI(payload);

    if (response.status === 201) {

      await getSingleAttendence(userDetails?._id).then((res) => {
        if (res?.status == 200) {
          dispatch(setLastSession(res?.data?.data));
        }
      });

      Swal.fire({
        html: `
          <div class="flex flex-col items-center gap-2 -mt-4">

            <div class="w-[120px] h-[120px] bg-[#E6FAEE] rounded-full flex items-center justify-center">
              ${renderToString(
                <IconCircleCheck size={64} color="#22C55E" />
              )}
            </div>

            <h2 class="text-[28px] font-bold text-[#4A5565]">
              Success
            </h2>

            <p class="text-[20px] font-medium text-[#4A5565] text-center">
              ${response?.data?.message}
            </p>

          </div>
        `,
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: {
          popup: "rounded-xl px-6 py-4",
          actions: "flex justify-center mt-4",
          confirmButton:
            "w-[100px] h-[44px] bg-[var(--bg-base-color)] text-white rounded-md flex items-center justify-center",
        },
      });

    } else {

      setValue(false);

      await Swal.fire({
        html: `
          <div class="flex flex-col items-center gap-2 -mt-4">

            <div class="w-[120px] h-[120px] bg-[#FEF9C2] rounded-full flex items-center justify-center">
              ${renderToString(
                <IconExclamationCircle size={64} color="#F59E0B" />
              )}
            </div>

            <h2 class="text-[28px] font-bold text-[#4A5565]">
              Warning
            </h2>
            <p class="text-[24px] font-medium text-[#4A5565] text-center">
              ${response?.response?.data?.error}
            </p>
          </div>
        `,
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: {
          popup: "rounded-xl px-6 py-4",
          actions: "flex justify-center mt-4",
          confirmButton:
            "w-[100px] h-[44px] bg-[var(--bg-base-color)] text-white rounded-md flex items-center justify-center",
        },
      });

    }

  } catch (error) {
    console.log("Error getting all Attendence", error);
  }
};

  const ClickHandler = async (e) => {
  if (e) {
    const result = await Swal.fire({
      html: `
        <div class="flex flex-col items-center gap-2 -mt-4">

          <div class="w-[120px] h-[120px] bg-[#FEF9C2] rounded-full flex items-center justify-center">
            ${renderToString(
              <IconExclamationCircle size={64} color="#F59E0B" />
            )}
          </div>

          <h2 class="text-[32px] font-bold text-[#4A5565] leading-[140%] font-[Nata Sans]">
            Alert
          </h2>

          <p class="text-[24px] font-medium text-[#4A5565] leading-[140%] font-[Nata Sans] text-center">
            Are you starting the work for the day?
          </p>

        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      buttonsStyling: false,

      customClass: {
        popup: "rounded-xl px-6 py-4",
        actions: "flex justify-center gap-4 mt-2",

       confirmButton:
          "w-[100px] h-[48px] text-white rounded-[4px] flex items-center justify-center bg-[var(--bg-base-color)]",

        cancelButton:
  "w-[100px] h-[48px] bg-white rounded-[4px] flex items-center justify-center border border-[color:var(--bg-base-color)] text-[var(--bg-base-color)]",
      },
    });

    if (result.isConfirmed) {
      attendencelogin();
    } else {
      setValue(false);

      await Swal.fire({
        html: `
          <div class="flex flex-col items-center gap-2 -mt-4">

            <div class="w-[120px] h-[120px] bg-[#FEF9C2] rounded-full flex items-center justify-center">
              ${renderToString(
                <IconExclamationCircle size={64} color="#F59E0B" />
              )}
            </div>

            <p class="text-[24px] font-medium text-[#4A5565] leading-[140%] font-[Nata Sans] text-center">
              Your current session will not be logged in to system!
            </p>

          </div>
        `,
        confirmButtonText: "Ok",
        buttonsStyling: false,

        customClass: {
          popup: "rounded-xl px-6 py-4",
          actions: "flex justify-center mt-2",

         confirmButton:
        "w-[100px] h-[48px] bg-[var(--bg-base-color)] text-white rounded-[4px] flex items-center justify-center",
        },
      });
    }
  } else {
    setBreakModal(true);
  }
};

  useMemo(() => {
    if (loginDetails) {
      if (loginDetails?.inTime && loginDetails?.outTime) {
        setValue(false);
      } else if (loginDetails?.inTime && !loginDetails?.outTime) {
        setValue(true);
      }

      if (latestBreak) {
        if (latestBreak?.inTime && !latestBreak?.outTime) {
          console.log('break is on')
          // setBreakModal(true);
          setValue(false);
        }
        else if (latestBreak?.inTime && latestBreak?.outTime) {
          console.log('break is off')
          // setBreakModal(true);
          setValue(true);
        }
      }
    } else {
      setValue(false);
    }
  }, [loginDetails, latestBreak])

  return (
    <div className="pt-[100px] ">
      <div className={`${pageClass}`}>
        {showGreeting && <Greetings />}

      </div>
      <div
        className={`flex items-center justify-between md:justify-end bg-[#FFFFFF]  border border-b-2 fixed top-0 right-0 py-3 px-4  ${openSlide ? "z-0" : "z-50"
          } md:px-3 pl-[36px] pr-[36px] w-full`}
      >
        <button
          className="relative shadow-none lg:hidden mr-5"
          onClick={() => setMobileSidebar(!mobileSidebar)}
        >
          {mobileSidebar ? (
            <IconX stroke={1.5} size={23} color="#000" />
          ) : (
            <IconMenu2 stroke={1.5} size={23} color="#000" />
          )}
        </button>
        <div className="flex items-center justify-center gap-6">
          <div className="flex items-center gap-4">
            <NotificationSlide
              setOpenSlide={setOpenSlide}
              openSlide={openSlide}
            />
            {userDetails?.role?.roleName !== "Admin" &&
              userDetails?.role?.roleName !== "SuperAdmin" && (
                <>
                  <Switch
                    checked={value}
                    onChange={ClickHandler}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    offColor="#ccc"
                    onColor="#4CAF50"
                  />
                  <SessionModel
                    checked={breakmodal}
                    breaks={Break}
                    tog={setValue}
                    change={setBreakModal}
                  />
                </>
              )}
          </div>
          <div className="flex items-center bg-white rounded-xl px-3 py-1  border" onClick={() => setCard(!card)}>
            <div className="flex-shrink-0">
              <img
                className="object-cover w-11 h-11 rounded-full"
                src={userImg}
                alt="user"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = userImg;
                }}
              />
            </div>
            <div className="hidden w-full ml-3 space-y-1 lg:block">
              <h4 className="capitalize text-lg font-bold leading-none whitespace-nowrap text-slate-800">
                {userDetails?.first_name} {userDetails?.last_name}
              </h4>
              <h4 className="text-[17px] font-semibold leading-none capitalize text-gray-600 pt-0.5">
                {userDetails?.role?.roleName}
              </h4>
            </div>
            <button
              className="hidden px-3 lg:block"
              onClick={() => setCard((prev) => !prev)}
            >
              <IconChevronDown stroke={1.5} size={23} color="#000" className={`transition-transform duration-300 ${card ? "rotate-180" : "rotate-0"
                  }`} />
            </button>
          </div>
        </div>
      </div>

      {/* Dropdown Card */}
      <div
        className={`${card ? "top-24 opacity-100" : "-top-96 opacity-0"
          } bg-white transition-all ease-in-out duration-700 fixed shadow-sm border right-6 py-2 rounded-lg z-20 px-4 lg:px-6 lg:py-1`}
      >
        <div className="flex items-center pb-3 border-b border-slate-200 lg:hidden">
          <div className="flex-shrink-0">
            <img className="w-10 h-10 rounded-full" src={userImg} alt="user" />
          </div>
          <div className="ml-3 space-y-1">
            <h4 className="text-sm font-semibold leading-none md:text-base font-tb text-slate-800">
              {userDetails?.first_name} {userDetails?.last_name}
            </h4>
            <h4 className="text-sm font-medium leading-none text-gray-600 capitalize md:text-base">
              {userDetails?.role?.roleName}
            </h4>
          </div>
        </div>
        <div className="p-2 pb-0">
          <NavLink
            to="/profile"
            onClick={() => setCard(!card)}
            className="flex items-center pb-2 space-x-2 transition duration-300 group"
          >
            <IconUser stroke={1.5}  size="23" color="#000" />
            <h4 className="text-sm font-semibold capitalize lg:text-lg md:text-base group-hover:text-sky-400 text-slate-700 pt-2">
              Profile
            </h4>
          </NavLink>
          <button
            onClick={() => {
              setCard(!card);
              nLogout();
            }}
            className="flex items-center pb-2 space-x-2 group"
          >
            <IconLogout stroke={1.5} size={23} color="#000" />
            <h4 className="text-sm font-semibold capitalize font-tb lg:text-lg md:text-base group-hover:text-red-500 text-slate-700 pt-2">
              Logout
            </h4>
          </button>
        </div>
      </div>

      {/* Logout Modal */}
      {/* <LogoutModel setOpen={setOpen} open={open} /> */}
    </div>
  );
}
